import { showSessionExpiredAlert } from "../components/alerts";

// Función para verificar si un token ha expirado
export const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expirationTime = payload.exp * 1000; // Convertir a milisegundos
    const currentTime = Date.now();

    return currentTime >= expirationTime;
  } catch (error) {
    console.error("Error al verificar la expiración del token:", error);
    return true; // Si hay error al decodificar, considerar como expirado
  }
};

// Función para obtener el tiempo restante del token en minutos
export const getTokenTimeRemaining = (token) => {
  if (!token) return 0;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expirationTime = payload.exp * 1000;
    const currentTime = Date.now();

    const timeRemaining = expirationTime - currentTime;
    return Math.max(0, Math.floor(timeRemaining / 60000)); // Retorna minutos restantes
  } catch (error) {
    console.error("Error al obtener el tiempo restante del token:", error);
    return 0;
  }
};

// Función para verificar y manejar la expiración del token
export const checkAndHandleTokenExpiration = () => {
  const token =
    localStorage.getItem("token") || localStorage.getItem("accessToken");

  // Si no hay token, no se muestra la alerta
  if (!token) {
    return true;
  }

  if (isTokenExpired(token)) {
    // Si el token ha expirado y no se ha mostrado la alerta
    if (!localStorage.getItem("sessionExpiredAlertShown")) {
      localStorage.setItem("sessionExpiredAlertShown", "true");
      showSessionExpiredAlert();
    }
    return true;
  }

  return false;
};

// Función para limpiar la bandera de alerta mostrada
export const clearSessionExpiredFlag = () => {
  localStorage.removeItem("sessionExpiredAlertShown");
};

// Función para configurar un temporizador que verifique la expiración del token
export const setupTokenExpirationCheck = (checkInterval = 60000) => {
  // Verificar inmediatamente
  checkAndHandleTokenExpiration();

  // Configurar verificación periódica
  const interval = setInterval(() => {
    checkAndHandleTokenExpiration();
  }, checkInterval);

  return interval;
};
